import { cacheDom } from "../utils/QuerySelectors.js"
import { toggleModal } from "../components/Popup.js"

const dom = {}
const qs = {
  swiper: 'data-media-swiper',
  showcasePopup: 'data-showcase-popup',
  showcaseSwiper: 'data-showcase-media',
  modal: 'data-popup',
}
const qsAll = {
  sections: 'data-section-type="three-up"',
  showcases: 'data-showcase',
}

const initShowcasePopup = (showcase) => {
  const popupContent = showcase.querySelector(`[${qs.showcasePopup}]`)
  toggleModal(true, popupContent.innerHTML, null, true)
  new Swiper(dom.modal.querySelector(`[${qs.showcaseSwiper}]`), {
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  })
  window.setupProductTiles(dom.modal.querySelectorAll('[product-tile]:empty'))
}

const initSection = (section) => {
  const showcases = section.querySelectorAll(`[${qsAll.showcases}]`)
  
  new Swiper(section.querySelector(`[${qs.swiper}]`), {
    slidesPerView: 1.2,
    slidesPerGroup: 1,
    breakpoints: {
      320: {
        slidesPerView: 1.2,
        slidesPerGroup: 1,
      },
      500: {
        slidesPerView: 2.2,
        slidesPerGroup: 2,
      },
      768: {
        slidesPerView: 3,
        slidesPerGroup: 3,
      },
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  })
  showcases.forEach(showcase => {
    showcase.addEventListener('click', () => {
      initShowcasePopup(showcase)
    })
  })
}

export const setupThreeUp = () => {
  cacheDom(dom, qs, qsAll)
  dom.sections.forEach(section => initSection(section))
}